__turbopack_context__.v({
  "dropdown": "DropdownMenu-module__O0juRG__dropdown",
  "menuPortal": "DropdownMenu-module__O0juRG__menuPortal",
  "trigger": "DropdownMenu-module__O0juRG__trigger",
});
